<template>
  <div class="grid grid-cols-12 col-gap-12 row-gap-12 mb-12">
    <Value class="col-span-6 lg:col-span-2"
           :value="portfolio.sum"
           :sum_usd="portfolio.sum_usd"/>
    <Profit class="col-span-6 lg:col-span-2"
            :profitability-year="portfolio.profitability_year"
            :profitability-total="portfolio.profitability_total"/>
    <ProfitDaily class="col-span-12 lg:col-span-8"
                 :daily-change="portfolio.profit_absolute_day"
                 :daily-change-percent="portfolio.profit_percent_day"
                 :month-change="portfolio.profit_absolute_month"
                 :month-change-percent="portfolio.profit_percent_month"
                 :year-change="portfolio.profit_absolute_year"
                 :year-change-percent="portfolio.profit_percent_year"
                 :profit-percent="portfolio.profit_percent"
                 :profit-absolute="portfolio.profit_absolute"/>
  </div>
</template>

<script>
import Profit from "@/components/cabinet/Investments/Dashboard/PortfolioStats/Profit";
import Value from "@/components/cabinet/Investments/Dashboard/PortfolioStats/Value";
import ProfitDaily from "@/components/cabinet/Investments/Dashboard/PortfolioStats/ProfitDaily";

export default {
  name: "PortfolioStats",
  props: {
    portfolio: {
      type: Object,
      required: true
    }
  },
  components: {ProfitDaily, Value, Profit}
}
</script>